import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import React from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu/';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler/';

import style from './actionable-filter-pill.module.less';

const autoClosingFilters = ['store', 'assignedTo', 'tag', 'productCategories', 'productType', 'productProfiles', 'status'];

const ActionableFilterPill = React.forwardRef(
  (
    { filterById = '', isLocked = false, isSelected = false, displayContent = null, dropdownContent = null, containerAllowedMeToClose },
    ref,
  ) => {
    if (isLocked) {
      return (
        <div ref={ref} className={style['ref-wrapper']}>
          <div className={style['lock-box']}>
            <FontAwesomeIcon className={style['lock-icon']} icon={faLock} />
            <div>{displayContent}</div>
          </div>
        </div>
      );
    }
    return (
      <div ref={ref} className={style['ref-wrapper']}>
        <DropdownMenu
          key={filterById}
          closeWhenChildrenClicked={autoClosingFilters.includes(filterById)}
          containerAllowedMeToClose={containerAllowedMeToClose}
          disabled={isLocked}
        >
          <DropdownMenuToggler
            className={classnames(style.toggler, {
              [style.selected]: isSelected,
            })}
            theme='link'
          >
            {displayContent}
          </DropdownMenuToggler>
          {dropdownContent}
        </DropdownMenu>
      </div>
    );
  },
);

ActionableFilterPill.propTypes = {
  filterById: PropTypes.string,
  isLocked: PropTypes.bool,
  isSelected: PropTypes.bool,
  displayContent: PropTypes.node,
  dropdownContent: PropTypes.node,
  containerAllowedMeToClose: PropTypes.func,
};

export default React.memo(ActionableFilterPill);
